import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterNotificationEmailByTitlePipe } from 'src/app/shared/pipes/filter-notificationEmail-by-title/filter-notificationEmail-by-title.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { NotificationEmailModalDetailComponent } from './modal/notificationEmail-modal-detail/notificationEmail-modal-detail.component';
import { NotificationEmailModalAjoutComponent } from './modal/notificationEmail-modal-ajout/notificationEmail-modal-ajout.component';
import { ListNotificationEmailComponent } from './list-notificationEmail/list-notificationEmail.component';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { NgxEditorModule } from 'ngx-editor';

@NgModule({
	declarations: [
		ListNotificationEmailComponent,
		NotificationEmailModalDetailComponent,
		NotificationEmailModalAjoutComponent
	],
	imports: [SharedModule, GestionDonneesModule, NgxEditorModule],
	providers: [FilterNotificationEmailByTitlePipe]
})

export class NotificationEmailModule {}
